import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import { AppDispatch, RootState } from '../../state';
import config from '../../config';
import { getValidAccessToken } from './accessTokenManager';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: '/api/',
    credentials: 'same-origin',
});

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions,
) => {
    const { dispatch, getState } = api;
    let token: string | null = null;
    try {
        token = await getValidAccessToken(dispatch as AppDispatch, getState as () => RootState);
    } catch (error) {
        if (error !== 'No refresh token available') {
            console.error('Error getting valid access token:', error);
        }
    }

    const modifiedArgs: FetchArgs & { headers: Headers } =
        typeof args === 'string'
            ? { url: args, headers: new Headers() }
            : { ...args, headers: new Headers(args.headers as HeadersInit) };

    modifiedArgs.headers.set('Client-Type', 'biolib-frontend');
    modifiedArgs.headers.set('Client-Version', config.frontendVersion);

    if (token && !modifiedArgs.headers.has('Authorization')) {
        modifiedArgs.headers.set('Authorization', `Bearer ${token}`);
    }

    return await rawBaseQuery(modifiedArgs, api, extraOptions);
};

export default baseQueryWithAuth;
